import { TypeAheadFilter } from '@components/table/filters/TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { useSearchPostRateDefaultFactorTypes } from '@services/postRateDefaultFactorType/useSearchPostRateDefaultFactorTypes';

export interface PostRateDefaultFactorTypeTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

export const PostRateDefaultFactorTypeTypeaheadFilter = (
  componentProps: PostRateDefaultFactorTypeTypeaheadFilterProps,
) => {
  const { value, disabled } = componentProps;
  const { items, isFetching } = useSearchPostRateDefaultFactorTypes({ sort: '+codeName', pageLimit: 100 });

  const options = items.map((item) => ({
    key: item.id,
    value: item.id,
    label: item.label,
    subLabel: item.codeName,
  }));

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={options}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      loading={isFetching}
      horizontalLabel={true}
    />
  );
};
